<template>
  <div>
    <v-dialog v-model="g703_report" max-width="1300" persistent scrollable>
      <v-card :loading="loading">
        <v-card-title class="p-1">
          <v-col cols="9" style="font-size: 18px;padding:0px" class="text-center mt-1">
            <b style="color:#666666;">AIA DOCUMENT G703</b>
          </v-col>
          <v-col cols="3" class="text-right fs-12">{{report_header_name}}</v-col>
        </v-card-title>
        <v-divider class></v-divider>
        <v-card-text style="height: 100%;" class>
          <v-row dense class="ml-1 custom-font-for-print">
            <v-col cols="5">
              <div>
                AIA DOCUMENT G702, APPLICATION AND CERTIFICATE FOR PAYMENT, containing
                <br />Contractor's signed certification is attached.
              </div>
              <div class="pt-3">
                In tabulations below, amounts are stated to the nearest dollar.
                <br />Use Column I on Contracts where variable retainage for line items may apply.
              </div>
            </v-col>
            <v-col cols="3" class="text-center">
              <div>
                <v-img :src="company_details.logo_path" width="30%" style="margin-left: 35%;"></v-img>
              </div>
              <div>
                <b style="font-size: 18px;">{{company_details.name}}</b>
              </div>
              <div class="license-number">{{company_details.license_number}}</div>
            </v-col>
            <v-col cols="4">
              <v-row dense class="report-header">
                <v-col
                  cols="6"
                  class="text-right"
                  v-if="g703_change_report==false"
                >APPLICATION NUMBER :</v-col>
                <v-col cols="6" class v-if="g703_change_report==false">
                  <v-select
                    :items="invoice_list"
                    item-text="invoice_number"
                    item-value="generated_inv_id"
                    v-model="invoice_no"
                    hide-details
                    dense
                    style="margin-top:-5px"
                    @change="getTotalPage();getAllInvoiceData()"
                  ></v-select>
                </v-col>

                <v-col cols="6" class="text-right" v-if="g703_change_report==true">CHANGE ORDER:</v-col>
                <v-col cols="6" class v-if="g703_change_report==true">
                  <v-select
                    :items="change_order_list"
                    item-text="change_order"
                    item-value="change_order"
                    v-model="change_order_id"
                    hide-details
                    dense
                    style="margin-top:-5px"
                    @change="getTotalPage();getAllInvoiceData()"
                  ></v-select>
                </v-col>

                <v-col cols="6" class="text-right">APPLICATION DATE :</v-col>
                <v-col cols="6">
                  <b>{{application_date}}</b>
                </v-col>
                <v-col cols="6" class="text-right">PERIOD :</v-col>
                <v-col cols="6">
                  <b>{{period_to}}</b>
                </v-col>
                <v-col cols="6" class="text-right">PROJECT NO :</v-col>
                <v-col cols="6">
                  <b>{{project_no}}</b>
                </v-col>
                <v-col cols="6" class="text-right">PROJECT NAME :</v-col>
                <v-col cols="6">
                  <b>{{project_name}}</b>
                </v-col>
                <v-col cols="6" class="text-right">CUSTOMER NAME :</v-col>
                <v-col cols="6">
                  <b>{{customer_name}}</b>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-data-table
            class="elevation-1 mt-1 rounded-0 my-transaction-table"
            :items="items"
            hide-default-footer
            mobile-breakpoint="50"
            dense
            disable-pagination
          >
            <template v-slot:body.prepend>
              <tr class="header-background white-border right-border-white">
                <td width="5%" class="text-center">A</td>
                <td width="27%" class="text-center">B</td>
                <td width="10%" class="text-center">C</td>
                <td width="10%" class="text-center">D</td>
                <td width="10%" class="text-center">E</td>
                <td width="10%" class="text-center">F</td>
                <td width="10%" class="text-center" colspan="2">G</td>
                <td width="10%" class="text-center">H</td>
                <td width="8%" class="text-center">I</td>
                <!-- <td
                  width="10%"
                  class="text-right pr-10"
                >J</td>-->
              </tr>
              <tr class="header-background right-border-white">
                <td width="5%" class="text-center">
                  Item
                  <br />No.
                </td>
                <td width="27%" class="text-center">Description of work</td>
                <td width="10%" class="text-center">
                  Scheduled
                  <br />Value
                </td>
                <td width="10%" class="text-center">
                  Previous
                  <br />(D+E)
                </td>
                <td width="10%" class="text-center">This Period</td>
                <td width="10%" class="text-center">Materials presently stored</td>
                <td width="10%" class="text-center">
                  Total
                  <br />Completed
                  <br />(D+E+F)
                </td>
                <td width="10%" class="text-center">
                  %
                  <br />(G/C)
                </td>
                <td width="10%" class="text-center">
                  Balance
                  <br />(C-G)
                </td>
                <td width="8%" class="text-center">Retainage</td>
              </tr>
            </template>
            <template v-slot:item="{ item, index}">
              <tr class="right-border-grey">
                <td width="5%" style="text-align:center;">{{index+1}}</td>
                <td width="27%" style="text-align:left;">{{item.group_name}}</td>
                <td
                  width="10%"
                  style="text-align:right;"
                >${{parseFloat(item.total_group_amount).toFixed(2)}}</td>
                <td
                  width="10%"
                  style="text-align:right;"
                >{{item.previous_amount != 0 ? '$'+getAmountFormat(item.previous_amount) : ''}}</td>
                <td
                  width="10%"
                  style="text-align:right;"
                >{{item.current_amount != 0 ? '$'+getAmountFormat(item.current_amount) : ''}}</td>
                <td width="10%" style="text-align:right;"></td>
                <td
                  width="10%"
                  style="text-align:right;"
                >{{item.completed_amount != 0 ? '$'+getAmountFormat(item.completed_amount) : ''}}</td>
                <td
                  width="10%"
                  style="text-align:right;"
                >{{item.per_amount ? getAmountFormat(item.per_amount)+ '%': ''}}</td>
                <td
                  width="10%"
                  style="text-align:right;"
                >${{getAmountFormat(item.per_amount)=='100' ? '0.00' : parseFloat(item.balance_amount).toFixed(2)}}</td>
                <td
                  width="8%"
                  style="text-align:right;"
                >{{ is_p_retainage === true && item.retainage_amount !=0 ? '$'+getAmountFormat(item.retainage_amount) : ''}}</td>
                <!-- <td width="10%" style="text-align:right;"></td> -->
              </tr>
            </template>
            <template v-slot:body.append>
              <tr class="grey-lighten-background right-border-grey">
                <td width="5%"></td>
                <td width="27%" style="text-align:left;">Total</td>
                <td
                  width="10%"
                  style="text-align:right;"
                >{{total_schedule != 0 ? '$'+parseFloat(total_schedule).toFixed(2): ''}}</td>
                <td
                  width="10%"
                  style="text-align:right;"
                >{{total_previous != 0 ? '$'+ getAmountFormat(total_previous) : ''}}</td>
                <td
                  width="10%"
                  style="text-align:right;"
                >{{total_current != 0 ? '$'+ getAmountFormat(total_current) : ''}}</td>
                <td width="10%" style="text-align:right;"></td>
                <td
                  width="10%"
                  style="text-align:right;"
                >{{total_completed !=0 ? '$'+getAmountFormat(total_completed) : ''}}</td>
                <td width="10%" style="text-align:right;"></td>
                <td width="10%" style="text-align:right;">{{'$' + total_balance }}</td>
                <td
                  width="8%"
                  style="text-align:right;"
                >{{ is_p_retainage === true && total_retainage != 0 ? '$'+getAmountFormat(total_retainage) : ''}}</td>
              </tr>
            </template>
          </v-data-table>
          <v-row dense class="ml-1 mt-2 custom-font-for-print report-header2">
            <v-col
              cols="12"
            >AIA DOCUMENT G703 - APPLICATION AND CERTIFICATE FOR PAYMENT - MAY 1983 EDITION - AIA C 1983</v-col>
            <v-col
              cols="12"
            >THE AMERICAN INSTITUTE OF ARCHITECTS, 1735 NEW YORK AVENUE, N.W., WASHINGTON, D.C., 20006</v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closePopup()" :disabled="loading">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :loading="loading"
            @click="loading=true;generateReport(false,false,'excel'); is_send_report = false;"
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-file</v-icon>Excel
          </v-btn>
          <v-btn
            :loading="loading"
            @click="loading=true;generateReport('whole_page',true); is_send_report = false;"
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-printer</v-icon>Print
          </v-btn>
          <v-btn
            :loading="loading"
            @click="generateReport(false); is_send_report = false; preview_pdf_dialog = true;"
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-content-save-outline</v-icon>Sign Online
          </v-btn>
          <v-btn
            @click="preview_pdf_dialog = true; is_send_report = true; generateReport(false);"
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-send</v-icon>Send for Signature
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="preview_pdf_dialog" max-width="800" persistent>
      <v-card :loading="preview_pdf_loading">
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <iframe :src="preview_page_link" frameborder="0" style="width:100%;height:800px"></iframe>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="error"
            @click="preview_pdf_dialog = false; user_sign_blob = []; customer_sign_blob = ''; active_page = 0;"
          >Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            @click="is_send_report ? email_dialog = true : signature_dialog = true"
            v-if="total_page == active_page"
            :loading="preview_pdf_loading"
          >Finish</v-btn>
          <v-btn
            v-else
            color="primary"
            class="text-capitalize"
            @click="is_send_report ? generateReport(false) : signature_dialog = true;"
            :loading="preview_pdf_loading"
          >Next Page</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SendMailDialog
      :email_id="email_ids"
      :email_dialog="email_dialog"
      @closeDialog="closeSendMailDialog"
      @sendMail="sendMail"
    />
    <Signatura
      :customer_sign="customer_sign_blob"
      :active_page="active_page"
      @updateValue="updateParent"
      @clearValue="clearParent"
      :project_details="project_details"
      :signature_dialog="signature_dialog"
    />
    <v-overlay absolute :value="loading" style="z-index: 999">
      <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
    </v-overlay>
  </div>
</template>
 <script>
import { getCompanyDetails } from "../../plugins/helper";
import Signatura from "../projects/Signatura";
import SendMailDialog from "../projects/SendMailDialog";
import axios from "../../plugins/axios";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      preview_pdf_loading: false,
      total_page: "",
      active_page: 0,
      user_sign_blob: [],
      customer_sign_blob: "",
      signature_dialog: false,
      loading: false,
      is_send_report: false,
      email_ids: null,
      email_id_arr: [],
      email_ids_error: null,
      email_dialog: false,
      send_pdf_loading: false,
      items: [],
      company_details: getCompanyDetails(),
      preview_pdf_dialog: false,
      preview_page_link: "",
      project_data_flag: "",
      total_balance: "",
      total_completed: "",
      total_current: "",
      total_previous: "",
      total_schedule: "",
      project_name: "",
      project_no: "",
      customer_name: "",
      is_p_retainage: "",
      application_date: "",
      period_to: "",
      total_change_order: "",
      total_retainage: "",
      contract_date: "",
      sales_income: "",
      change_order_list: [],
      invoice_list: [
        {
          amount: "0",
          invoice_number: "0",
          generated_inv_id: "0"
        }
      ],
      invoice_no: "0",
      change_order_id: ""
    };
  },
  props: [
    "g703_report",
    "project_details",
    "generate_invoice_project",
    "selectedRows",
    "invoice_id",
    "g703_change_report",
    "report_header_name"
  ],
  watch: {
    g703_report: function(value) {
      if (value) {
        if (this.invoice_id) {
          this.invoice_no = this.invoice_id;
        }
        this.getData();
      }
    },
    generate_invoice_project: function(value) {
      if (value) {
        this.getData();
      }
    },
    selectedRows: function(value) {
      this.items = this.items.filter(item => {
        item.current_period = 0;
        return item;
      });
      this.items = this.items.filter(item2 => {
        value.filter(item => {
          if (item2.invoice_group_id == item.invoice_group_id) {
            item2.current_period =
              parseFloat(item2.current_period) + parseFloat(item.rev_amount);
          }
        });
        return item2;
      });
    }
  },
  computed: {
    user_name() {
      return localStorage.getItem("user_name");
    }
  },
  components: {
    Signatura,
    SendMailDialog
  },
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    getAmountFormat(value) {
      if (value) {
        return value.toString().replace("-", "");
      } else {
        return 0;
      }
    },
    getData() {
      if (this.project_details.project_work == "remodeling") {
        this.project_data_flag = 2;
      } else if (this.project_details.project_work == "new_construction") {
        this.project_data_flag = 1;
      } else if (this.project_details.project_work == "project_management") {
        this.project_data_flag = 4;
      }
      this.preview_page_link = "";
      this.active_page = 0;
      this.user_sign_blob = [];
      this.customer_sign_blob = "";
      // this.getReportDetails();
      if (this.g703_change_report) {
        this.getChangeOrderList();
      } else {
        this.getInvoiceList();
      }
      setTimeout(() => {
        this.getTotalPage();
      }, 2000);
    },

    sendMail(variable) {
      this.email_id_arr = variable;
      this.sendSalesInvoiceReport();
    },
    closeSendMailDialog() {
      this.email_dialog = false;
      this.preview_pdf_dialog = false;
      this.user_sign_blob = [];
      this.customer_sign_blob = "";
      this.active_page = 0;
    },
    updateParent(variable) {
      if (variable.user_sign_blob) {
        this.user_sign_blob.push({
          page: this.active_page,
          sign_blob: variable.user_sign_blob
        });
      }
      if (variable.customer_sign_blob && this.active_page == 1) {
        this.customer_sign_blob = variable.customer_sign_blob;
      }
      this.signature_dialog = false;
      if (this.is_send_report) {
        if (this.total_page == this.active_page) {
          this.email_dialog = true;
          this.email_ids =
            this.project_details.customer.email +
            "@" +
            this.project_details.customer.email_domain.domain;
        } else {
          this.generateReport(false);
        }
      } else {
        if (this.total_page == this.active_page) {
          this.generateReport(true);
        } else {
          this.generateReport(false);
        }
      }
    },
    clearParent(variable) {
      console.log(variable);
      this.signature_dialog = false;
    },
    closePopup() {
      this.$emit("updateValue");
      this.invoice_list = [
        {
          amount: "0",
          invoice_number: "0",
          generated_inv_id: "0"
        }
      ];
      this.invoice_no = "0";
    },
    getTotalPage() {
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      var formData = new FormData();
      formData.append("project_id", this.project_details.project_id);
      formData.append("user_name", localStorage.getItem("user_id"));
      formData.append("company_id", company_data.company_id);
      formData.append("generate_pdf_flag", "get_total");
      formData.append("project_data_flag", this.project_data_flag);
      formData.append("report_name", "g_703");
      formData.append("report_header_name", this.report_header_name);
      this.loading = true;
      axios
        .post("generate_report_pdf", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data.status) {
            this.total_page = response.data.total_page;
          }
          this.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          this.loading = false;
        });
    },
    generateReport(is_past_page, direct_print = false, $excel = "") {
      this.preview_pdf_loading = true;
      this.active_page++;
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      // let url = 'flag=save&project_id='+this.project_details.project_id+'&user_name='+localStorage.getItem('user_id')+'&company_id='+company_data.company_id+'&sign='+this.sign_blob;
      var formData = new FormData();

      if (is_past_page) {
        if (this.user_sign_blob) {
          for (let key in this.user_sign_blob) {
            formData.append(
              `user_sign_blob[${this.user_sign_blob[key].page}]`,
              this.user_sign_blob[key].sign_blob
            );
          }
        }
        if (this.customer_sign_blob) {
          formData.append(`customer_sign_blob`, this.customer_sign_blob);
        }
        formData.append("generate_pdf_flag", "whole_page");
      } else {
        formData.append("generate_pdf_flag", "single_page");
      }
      formData.append("flag", "save");
      formData.append("project_id", this.project_details.project_id);
      formData.append("user_name", localStorage.getItem("user_id"));
      formData.append("company_id", company_data.company_id);
      formData.append("total_page", this.total_page);
      formData.append("active_page", this.active_page);
      formData.append("project_data_flag", this.project_data_flag);
      formData.append("report_name", "g_703");
      formData.append("report_header_name", this.report_header_name);
      formData.append("direct_print", direct_print);
      formData.append("generate_invoice_id", this.invoice_no);
      formData.append("g703_change_report", this.g703_change_report);
      formData.append("g703_change_order_id", this.change_order_id);
      formData.append("is_excel", $excel);
      axios
        .post("generate_report_pdf", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data.is_excel == true) {
            this.preview_pdf_loading = false;
            this.loading = false;
            window.open(response.data.file_url, "_blank");
          } else {
            if (is_past_page) {
              if (response.data.status) {
                if (direct_print) {
                  this.loading = false;
                  var File_url = response.data.file_url;
                  window.open(File_url, "Download");
                } else {
                  this.setAlert({
                    show: true,
                    variant: "primary",
                    message: response.data.message,
                    dismissCountDown: 0
                  });
                  this.closePopup();
                }
                this.preview_pdf_dialog = false;
              }
            } else {
              this.preview_pdf_loading = false;
              this.preview_page_link = response.data.preview_page_link;
            }
          }

          this.preview_pdf_loading = false;
        })
        .catch(function(error) {
          console.log(error);
          this.preview_pdf_loading = false;
        });

      // let url = 'flag=save&project_id='+this.project_details.project_id+'&user_name='+localStorage.getItem('user_id')+'&company_id='+company_data.company_id+'&sign='+this.sign_blob;
      // this.loading = true;
      // axios
      // .get("generate_sales_invoice_pdf?" + url)
      // .then(response => {
      //   if(response.data.status) {
      //     this.setAlert({
      //       show: true,
      //       variant: "primary",
      //       message: response.data.message,
      //       dismissCountDown: 0
      //     });
      //   }
      //   this.loading = false;
      //   this.closePopup();
      // })
      // .catch(function(error) {
      //   console.log(error);
      //   this.loading = false;
      // });
    },
    sendSalesInvoiceReport() {
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      let data = {
        flag: "mail",
        project_id: this.project_details.project_id,
        user_name: localStorage.getItem("user_id"),
        company_id: company_data.company_id,
        active_page: this.active_page,
        total_page: this.total_page,
        email_id_arr: this.email_id_arr,
        email_ids: this.email_ids,
        generate_pdf_flag: "whole_page",
        project_data_flag: this.project_data_flag,
        report_name: "g_703"
      };
      if (this.user_sign_blob) {
        data.user_sign_blob = this.user_sign_blob;
      }
      if (this.customer_sign_blob) {
        data.customer_sign_blob = this.customer_sign_blob;
      }

      this.send_pdf_loading = true;
      axios
        .post("generate_report_pdf", data)
        .then(response => {
          this.email_ids_error = null;
          if (response.data.status) {
            this.email_dialog = false;
            this.setAlert({
              show: true,
              variant: "primary",
              message: response.data.message,
              dismissCountDown: 0
            });
            this.preview_pdf_dialog = false;
            this.closePopup();
          } else {
            this.email_ids_error = response.data.errors["email_ids"];
          }
          this.send_pdf_loading = false;
        })
        .catch(function(error) {
          console.log(error);
          this.send_pdf_loading = false;
        });
    },
    getReportDetails() {
      let _self = this;
      this.loading = true;
      axios
        .get(
          "get_item_group?project_id=" +
            this.project_details.project_id +
            "&project_data_flag=" +
            this.project_data_flag
        )
        .then(response => {
          let response_data = response.data;
          _self.items = response_data.data;
          _self.total_amt = response_data.total_amt;
          _self.loading = false;
          console.log("_self.items", _self.items);
        })
        .catch(function(error) {
          console.log(error);
          _self.loading = false;
        });
    },
    getAllInvoiceData() {
      let _self = this;
      let invoice_no = _self.invoice_no;
      _self.items = [];
      _self.loading = true;
      axios
        .get(
          "get_all_invoice_detail?project_id=" +
            this.project_details.project_id +
            "&project_data_flag=" +
            this.project_data_flag +
            "&generate_invoice_id=" +
            invoice_no +
            "&g703_change_report=" +
            this.g703_change_report +
            "&g703_change_order_id=" +
            this.change_order_id
        )
        .then(response => {
          let response_data = response.data;
          _self.items = response_data.data;
          _self.total_balance = response_data.total_balance;
          _self.total_completed = response_data.total_completed;
          _self.total_current = response_data.total_current;
          _self.total_previous = response_data.total_previous;
          _self.total_schedule = response_data.total_schedule;
          _self.project_name = response_data.project_name;
          _self.project_no = response_data.project_no;
          _self.is_p_retainage = response_data.is_p_retainage;
          _self.customer_name = response_data.customer_name;
          _self.application_date = response_data.application_date;
          _self.period_to = response_data.period_to;
          _self.total_retainage = response_data.total_retainage;
          _self.contract_date = response_data.contract_date;
          _self.sales_income = response_data.sales_income;

          setTimeout(() => {
            _self.loading = false;
          }, 1000);
        })
        .catch(function(error) {
          console.log(error);
          _self.loading = false;
        });
    },
    getInvoiceList() {
      let _self = this;
      axios
        .get(
          "get_project_invoice_list?project_id=" +
            this.project_details.project_id
        )
        .then(response => {
          let response_data = response.data;
          response_data.invoice_list.map(function(item) {
            _self.invoice_list.unshift(item);
          });

          if (_self.invoice_id) {
            _self.invoice_no = _self.invoice_id ? _self.invoice_id : "0";
          } else {
            _self.invoice_no = response_data.last_invoice
              ? response_data.last_invoice
              : "0";
          }

          _self.getAllInvoiceData();
        })
        .catch(function(error) {
          console.log(error);
          _self.loading = false;
        });
    },
    getChangeOrderList() {
      let _self = this;
      axios
        .get(
          "get_project_change_order_list?project_id=" +
            this.project_details.project_id +
            "&get_all=true"
        )
        .then(response => {
          let response_data = response.data;
          response_data.change_order_list.map(function(item, index) {
            if (index == 0) {
              _self.change_order_id = item.change_order;
            }
            _self.change_order_list.push(item);
          });
          _self.getAllInvoiceData();
        })
        .catch(function(error) {
          console.log(error);
          _self.loading = false;
        });
    }
  },
  created: function() {},
  mounted: function() {
    this.invoice_list = [
      {
        amount: "0",
        invoice_number: "0",
        generated_inv_id: "0"
      }
    ];
    this.change_order_list = [];
    // this.$refs.userSignaturePad.openSignaturePad();
    // this.$refs.customerSignaturePad.openSignaturePad();
  }
};
</script>
 
 <style>
.sales-invoice-report p {
  margin-bottom: 0px;
}
</style>